var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("billingPage.PostageRechargeManualMatchTitle"),
        visible: _vm.dialogVisible,
        width: "860px",
        "destroy-on-close": "",
        "append-to-body": "",
        "before-close": _vm.hide,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "manual-match" },
        [
          _c(
            "div",
            { staticClass: "manual-match__target" },
            [
              _c("div", { staticClass: "manual-match__target-title" }, [
                _vm._v(_vm._s(_vm.$t("billingPage.PostageRechargeTargetItem"))),
              ]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "manual-match__label" }, [
                      _vm._v(_vm._s(_vm.$t("billingPage.consignmentNum"))),
                    ]),
                    _c("div", { staticClass: "manual-match__value" }, [
                      _vm._v(_vm._s(_vm.target.consignmentNum)),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "manual-match__label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("billingPage.PostageRechargeInvoicePrice")
                        )
                      ),
                    ]),
                    _c("div", { staticClass: "manual-match__value" }, [
                      _vm._v(_vm._s(_vm.formatMoney(_vm.target.invoicePrice))),
                    ]),
                  ]),
                  _c("el-col", { attrs: { span: 8 } }, [
                    _c("div", { staticClass: "manual-match__label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("billingPage.PostageRechargeRawData"))
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "manual-match__value is-raw",
                        attrs: {
                          title: _vm.formatRawData(_vm.getRawData(_vm.target)),
                        },
                        on: {
                          click: function ($event) {
                            _vm.copyRawData(_vm.getRawData(_vm.target))
                          },
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatRawData(_vm.getRawData(_vm.target))
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              staticClass: "manual-match__search",
              attrs: { "label-position": "top" },
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("billingPage.PostageRechargeSearchOrder"),
                  },
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        placeholder: _vm.$t(
                          "billingPage.PostageRechargeSearchOrderPlaceholder"
                        ),
                        clearable: "",
                      },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.searchOrders.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.searchKeyword,
                        callback: function ($$v) {
                          _vm.searchKeyword =
                            typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "searchKeyword",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "append",
                            icon: "el-icon-search",
                            loading: _vm.searchLoading,
                          },
                          on: { click: _vm.searchOrders },
                          slot: "append",
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("searchText")) + " ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              attrs: { data: _vm.orderList, border: "", "max-height": "320px" },
              on: { "row-click": _vm.selectRow },
            },
            [
              _c("el-table-column", {
                attrs: { width: "55", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-radio",
                          {
                            attrs: { label: scope.row.logisticsNo },
                            on: {
                              change: function ($event) {
                                return _vm.selectRow(scope.row)
                              },
                            },
                            model: {
                              value: _vm.selectedLogisticsNo,
                              callback: function ($$v) {
                                _vm.selectedLogisticsNo = $$v
                              },
                              expression: "selectedLogisticsNo",
                            },
                          },
                          [_c("span")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "orderId",
                  label: _vm.$t("billingPage.PostageRechargeOrderNumber"),
                  align: "center",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "clientName",
                  label: _vm.$t("billingPage.CustomerName"),
                  align: "center",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "logisticsNo",
                  label: _vm.$t("billingPage.consignmentNum"),
                  align: "center",
                  "min-width": "180",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.selectedRow
            ? _c("span", { staticClass: "manual-match__current" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("billingPage.PostageRechargeCurrentSelection")
                    ) +
                    ": " +
                    _vm._s(_vm.selectedRow.orderId) +
                    " / " +
                    _vm._s(_vm.selectedRow.logisticsNo) +
                    " "
                ),
              ])
            : _vm._e(),
          _c("el-button", { on: { click: _vm.hide } }, [
            _vm._v(_vm._s(_vm.$t("cancelText"))),
          ]),
          _c(
            "el-button",
            {
              attrs: {
                type: "primary",
                loading: _vm.confirmLoading,
                disabled: !_vm.selectedRow,
              },
              on: { click: _vm.confirm },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("billingPage.PostageRechargeConfirmMatch")) +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }